// extracted by mini-css-extract-plugin
export default {"closeCross":"OnboardResellerPopup_closeCross__wv2D2","loading-customers":"OnboardResellerPopup_loading-customers__kdRWQ"};